import {RsDocumentTemplateGroup} from "../../api/dto/RsDocumentTemplateGroup";
import {useCallback, useState} from "react";
import {DocumentTemplateGroupService} from "../../service/DocumentTemplateGroupService";

interface DocumentTemplateGroupViewModelReturn {

    loading: boolean;
    documentTemplateGroupList: RsDocumentTemplateGroup[];
    retrieveDocumentTemplateGroupsByVerification: (verificationId: string) => void

}

export const DocumentTemplateGroupViewModel = (): DocumentTemplateGroupViewModelReturn => {

    const [documentTemplateGroupList, setDocumentTemplateGroupList] = useState<RsDocumentTemplateGroup[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const retrieveDocumentTemplateGroupsByVerification = useCallback(async (verificationId: string) => {
        const service = DocumentTemplateGroupService.getInstance();
        setLoading(true)
        const groupList = await service.retrieveDocumentTemplateGroupsByVerificationId(verificationId)
        setDocumentTemplateGroupList(groupList)
        setLoading(false)
    }, [])

    return {
        loading,
        documentTemplateGroupList,
        retrieveDocumentTemplateGroupsByVerification,
    }

}